import { createIsomorphicFn } from "@tanstack/react-start";
import { sanitizeHtmlClient } from "./sanitize.client";
import { sanitizeHtml } from "./sanitize.server";

export const sanitizeEmbedHtml = createIsomorphicFn()
  .server((html: string) => sanitizeHtml(html))
  .client((html: string) => sanitizeHtmlClient(html));
